import { render, staticRenderFns } from "./ContractDuration.vue?vue&type=template&id=5364968a&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/hemmelig/components/contract/ContractDuration.vue
// module id = null
// module chunks = 